import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';


export interface ChatSuggestion {
  text: string;
  icon: any;
}

export const CHAT_SUGGESTIONS: ChatSuggestion[] = [
  { 
    text: 'Suggest a cross-sell message for someone who bought a smartphone.',
    icon: SmartphoneOutlinedIcon 
  },
  {
    text: "Create a cohort to target customers who haven't purchased in the last 6 months.",
    icon: ChatOutlinedIcon
  },
];

export const DEFAULT_PLACEHOLDERS = {
  INITIAL: 'What can you do?',
  FOLLOWUP: 'What other help do you need?',
} as const;